import React, { useState, useEffect, useContext } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DataService from "../../../../../Service";
import MenuItem from "@material-ui/core/MenuItem";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from "../../../../../Components/CustomInput";
import CustomSelect from "../../../../../Components/CustomSelect";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import { Divider } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import DataClient from "../../../../../Service/general_data_service";

import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
    width: "460px", padding: theme.spacing(3),
  },
  title: {
    textTransform: "inherit",
    fontSize: "16px",
    fontFamily: "Open Sans",
  },
  actionButtons: {
    paddingTop: "35px",
    textAlign: "right",

    "& button": {
      // marginRight: "20px",
      fontSize: "14px",
      fontFamily: "Open Sans",
      lineHeight: "16px",
      height: "35px",
    },
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),

  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h2" style={{
        fontSize: "18px",
        fontFamily: "Open Sans", fontWeight: 700
      }}>{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function ManageModules(props) {
  const classes = useStyles();
  const { action, handleClose, data } = props;
  const [feildName, setFeildName] = useState("");
  const [openNewFeild, setOpenNewFeild] = useState("");
  // const message = useContext(ToastMessageContext);
  const [loading, setLoading] = useState(false);
  const [openNewFeildDialog, setOpenNewFeildDialog] = useState(false);
  const [openWarning, setOpenWarning] = useState("");
  const [feildValue, setFeildValue] = useState([]);
  const dispatch = useDispatch();
  const [userData, setUserData] = useState([]);
  const [moduleData, setModuleData] = useState([]);

  useEffect(() => {
    setFeildValue(data.module_form_fields);
  }, [feildValue]);

  const onClickLoader = () => {
    setLoading(true);
    setTimeout(() => setLoading(false), 3000); //3 seconds
  };

  const setOpen = () => {
    setOpenNewFeild("open");
    setOpenNewFeildDialog(true);
  };
  const handleNewFeildClose = () => {
    setOpenNewFeildDialog(false);
  };
  const onChangeItem = (selectedItemValue, inputId) => {
    console.log(selectedItemValue, inputId);
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
  };
  const setInputStateModule = (inputStateValue, inputId) => {
    setModuleData({ ...moduleData, [inputId]: inputStateValue });
  };
  const handleCreate = (formData) => {
    setLoading(true);
    DataService.createData({ ...moduleData }, "module_setup_create")
      .then((res) => {
        if (res.module_setup) {
          handleClose(res.module_setup);
          dispatch(showSnackbar("success", [res.message], 5000));
          // props.moduleSetup();
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        dispatch(showSnackbar("error", [["" + err.errors]], 5000));
      });
  };

  const handleUpdate = (formData) => { };

  const handleDeleteModule = () => {
    setLoading(true);
    DataService.deleteDirectFeild(
      `module_setups/delete_module?module_id=${data.id}`
    )
      .then((res) => {
        if (res.success) {
          handleClose(res.data);
          props.moduleSetup();
          dispatch(showSnackbar("success", [res.message], 5000));
          // message.showToastMessage({ open: true, message: "New Supplier added
          // successfully", variant: "success" });   props.getSupplierList();
        } else {
          // message.showToastMessage({ open: true, message: res.errors ?
          // res.errors.join(',') : "Something went wrong. Try Again", variant: "error" });
          setLoading(false);
        }
      })
      .catch((err) => {
        dispatch(showSnackbar("error", [["" + err.errors]], 5000));
        handleClose();
        // message.showToastMessage({ open: true, message: "Something went wrong. Try
        // Again", variant: "error" });
        setLoading(false);
      });
  };

  const handleDeleteFeild = () => {
    setLoading(true);
    console.log(`feildName`, feildName);
    DataService.deleteDirectFeild(
      `/module_setups/delete_form_field?module_id=${props.moduleId}&field_name=${feildName}`
    )
      .then((res) => {
        if (res.success) {
          handleNewFeildClose(res.data);
          dispatch(showSnackbar("success", ["Success!"], 5000));
          props.moduleSetup();

          // message.showToastMessage({ open: true, message: "New Supplier added successfully", variant: "success" });
          //   props.getSupplierList();
        } else {
          // message.showToastMessage({ open: true, message: res.errors ? res.errors.join(',') : "Something went wrong. Try Again", variant: "error" });
          setLoading(false);
        }
      })
      .catch((err) => {
        // setLoading(false);
        dispatch(showSnackbar("error", [["" + err.errors]], 5000));
      });
  };
  const setInputState = (inputStateValue, inputId) => {
    setUserData({ ...userData, [inputId]: inputStateValue });
  };

  const handleCreateNewFeild = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    setLoading(true);
    DataService.createData(
      { module_id: props.moduleId, ...userData },
      "module_setups_new_feild"
    )
      .then((res) => {
        if (res.success) {
          handleNewFeildClose(res.data);

          props.moduleSetup();
          // message.showToastMessage({ open: true, message: "New Supplier added successfully", variant: "success" });
          //   props.getSupplierList();
        } else {
          // message.showToastMessage({ open: true, message: res.errors ? res.errors.join(',') : "Something went wrong. Try Again", variant: "error" });
          setLoading(false);
        }
      })
      .catch(() => {
        // message.showToastMessage({ open: true, message: "Something went wrong. Try Again", variant: "error" });
        setLoading(false);
      });
  };
  const handleUpdateModule = (formData) => {
    setLoading(true);
    const statusData = {
      ...moduleData,
      module_id: props.moduleId
    }
    DataClient.update(statusData, `/module_setups/update_module`)

      // DataService.updateData( { module_id: props.moduleId, ...moduleData}, "update_module")
      .then((res) => {
        if (res.success) {
          handleClose(res.data);
          props.moduleSetup();
        } else {
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    for (const iterator of formData) {
      console.log(iterator);
    }

    if (action === "create") {
      handleCreate(formData);
    } else if (action === "edit") {
      handleUpdate(formData);
    } else if (action === "editModule") {
      handleUpdateModule(formData);
    }
    else if (action === "delete") {
      handleDeleteModule()
    }
  };

  return (
    <div>
      <Dialog
        maxWidth={"sm"}
        style={{ height: "70%" }}
        open={true}
        onClose={handleClose}
        aria-labelledby="base-station-manage"
      >
        <DialogTitle id="customized-dialog-title" style={{
          fontSize: "18px",
          fontFamily: "Open Sans",
        }}>
          {action === "edit" && (
            <IconButton
              className={classes.iconButton}
              onClick={handleClose}
              aria-label="menu"
            >
              <ArrowBackIcon />
            </IconButton>
          )}
          {action === "edit" ? "Midpoint review" : ""}
          {action === "create" ? "Creating new modules" : ""}
          {action === "editModule" ? "Update module" : ""}
        </DialogTitle>
        <Divider />
        <DialogContent style={{ margin: "0px auto" }}>
          {action !== "delete" ? (
            <div className={classes.formWrapper}>
              <Typography
                variant="subtitle2"
                color="secondary"
                className={classes.title}
              >
                {/* {action !== "edit" ? `${action}Modules` :''}  */}
              </Typography>
              <form onSubmit={handleSubmit}>
                <Grid
                  container
                  spacing={1}
                  alignItems={"center"}
                  justify={"flex-start"}
                >
                  {action !== "edit" && (
                    <React.Fragment>
                      <Grid item xs={3}>
                        <Typography
                          variant="subtitle2"
                          className={classes.title}
                        >
                          Module name
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <CustomInput
                          id="module_name"
                          parentcall={setInputStateModule}
                          required
                          autoFocus
                          variant="outlined"
                          style={{
                            backgroundColor: "#fff", fontSize: "16px",
                            fontFamily: "Open Sans",
                          }}
                          defaultValue={data.module_name}
                          placeholder="Module name"
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <Typography
                          variant="subtitle2"
                          className={classes.title}
                        >
                          Description
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <CustomInput
                          id="description"
                          parentcall={setInputStateModule}
                          required
                          multiline
                          rows={5}
                          // autoFocus
                          variant="outlined"
                          style={{
                            backgroundColor: "#fff", fontSize: "16px",
                            fontFamily: "Open Sans",
                          }}
                          defaultValue={data.description}
                          placeholder="Description"
                        />
                      </Grid>
                    </React.Fragment>
                  )}
                </Grid>
                {action === "edit"
                  ? feildValue &&
                  feildValue.map((feild) => (
                    <React.Fragment>
                      <Grid
                        container
                        spacing={1}
                        alignItems={"center"}
                        justify={"flex-start"}
                      >
                        <Grid item xs={4}>
                          <Typography
                            variant="subtitle2"
                            color="secondary"
                            className={classes.title}
                          >
                            {feild.field_name}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          {feild.field_type === "text" ? (
                            <CustomInput
                              variant="outlined"
                              InputLabelProps={{ shrink: true }}
                              required
                            />
                          ) : (
                            ""
                          )}
                          {feild.field_type === "text_area" ? (
                            <CustomInput
                              variant="outlined"
                              multiline
                              InputLabelProps={{ shrink: true }}
                              required
                            />
                          ) : (
                            ""
                          )}
                          {feild.field_type === "date" ? (
                            // <CustomInput
                            //   variant="outlined"
                            //   type="date"
                            //   format="dd/MM/yyyy"  
                            //   InputLabelProps={{ shrink: true }}
                            //   required
                            // />
                            <KeyboardDatePicker
                              fullWidth
                              placeholder="MM/DD/YYYY"
                              inputVariant="outlined"
                              size="small"
                              disabled
                              defaultValue="dd/MM/yyyy"
                              margin="normal"
                              format="dd/MM/yyyy"
                              disablePast={false}

                            />
                          ) : (
                            ""
                          )}
                        </Grid>
                        <Grid item xs={2}>
                          <IconButton
                            aria-label="close"
                            className={classes.closeButton}
                            onClick={() => {
                              setFeildName(feild.field_name);
                              setOpenWarning("open");
                              setOpen();
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  ))
                  : ""}
                <div className={classes.actionButtons}>
                  {action === "create" && (
                    <Button
                      disableElevation
                      disabled={loading}
                      type="button"
                      variant={"contained"}
                      onClick={handleClose}
                      style={{ textTransform: "initial" }}
                    >
                      Cancel
                    </Button>
                  )}&nbsp;&nbsp;&nbsp;&nbsp;
                  {action === "create" && (
                    <Button
                      disableElevation
                      disabled={loading}
                      type="submit"
                      variant={"contained"}
                      color="secondary"
                      style={{ textTransform: "initial" }}
                    >
                      {loading && (
                        <CircularProgress
                          className={classes.circularProgress}
                          size={20}
                        />
                      )}
                      {action === "create" ? "Create" : ""}
                    </Button>
                  )}
                  {action === "editModule" && (
                    <React.Fragment>

                      <Button
                        disableElevation
                        disabled={loading}
                        type="button"
                        variant={"contained"}
                        onClick={handleClose}
                        style={{ textTransform: "initial" }}
                      >
                        Cancel
                      </Button>&nbsp;&nbsp;&nbsp;&nbsp;
                      <Button
                        disableElevation
                        disabled={loading}
                        type="submit"
                        variant={"contained"}
                        color="secondary"
                        style={{ textTransform: "initial" }}
                      >
                        {action === "editModule" ? "Update" : ""}
                      </Button>
                    </React.Fragment>

                  )}
                  {action === "edit" && (
                    <Button
                      disableElevation
                      onClick={setOpen}
                      disabled={loading}
                      variant={"contained"}
                      color="primary"
                      style={{ textTransform: 'initial' }}
                    >
                      Add new field
                    </Button>
                  )}
                </div>

              </form>
            </div>
          ) : (
            <div className={classes.formWrapper}>
              Warning, deleting this module will delete both the module and
              their items from the ordering list. Are you sure?
              <div className={classes.actionButtons}>
                <Button
                  disableElevation
                  disabled={loading}
                  type="button"
                  variant={"contained"}
                  onClick={handleClose}
                  style={{ textTransform: "initial" }}
                >
                  Cancel
                </Button>&nbsp;&nbsp;&nbsp;&nbsp;
                <Button
                  disableElevation
                  disabled={loading}
                  type="button"
                  variant={"contained"}
                  onClick={handleDeleteModule}
                  color="secondary"
                  style={{ textTransform: "initial" }}
                >
                  Yes, Confirm
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        maxWidth={"sm"}
        open={openNewFeildDialog}
        onClose={handleNewFeildClose}
        aria-labelledby="base-station-manage"
      >
        <DialogContent>
          {openNewFeild === "open" && openWarning !== "open" ? (
            <div className={classes.formWrapper}>
              <Typography
                variant="subtitle2"
                color="secondary"
                className={classes.title}
              >
                Adding New Feild
              </Typography>
              <form onSubmit={handleCreateNewFeild}>
                <Grid
                  container
                  spacing={1}
                  alignItems={"center"}
                  justify={"flex-start"}
                >
                  <React.Fragment>
                    <Grid item xs={6}>
                      <Typography
                        variant="subtitle2"
                        color="secondary"
                        className={classes.title}
                      >
                        Feild Name
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <CustomInput
                        id="field_name"
                        parentcall={setInputState}
                        required
                        variant="outlined"
                        style={{ backgroundColor: "#fff" }}
                        defaultValue={data.field_name}
                        placeholder="Label"
                      />
                    </Grid>
                  </React.Fragment>
                  <Grid item xs={6}>
                    <Typography
                      variant="subtitle2"
                      color="secondary"
                      className={classes.title}
                    >
                      Field Type
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <CustomInput
                      id="field_type"
                      variant="outlined"
                      placeholder="Feild Type"
                      // onChange={()=>setError({...error,handover:false})}
                      InputLabelProps={{ shrink: true }}
                      select
                      required
                    >
                      <MenuItem value={"Drop down"}>Drop down</MenuItem>
                      <MenuItem value={"text"}>Text</MenuItem>
                      <MenuItem value={"text_area"}>Text Area</MenuItem>
                    </CustomInput>

                    {/* <CustomSelect
                          id="field_type"
                          displayEmpty
                          variant="outlined"
                          labelText="Select field type"
                          defaultValue={ userData.field_type}
                          itemArr={["Drop down","Text","Text area"]}
                          parentcall={onChangeItem}
                      
                        /> */}
                  </Grid>
                </Grid>

                <div className={classes.actionButtons}>
                  <Button
                    disableElevation
                    disabled={loading}
                    type="button"
                    variant={"contained"}
                    onClick={handleNewFeildClose}
                    style={{ textTransform: "initial" }}
                  >
                    Cancel
                  </Button>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <Button
                    disableElevation
                    disabled={loading}
                    type="submit"
                    style={{ textTransform: "initial" }}
                    // onClick ={handleCreateNewFeild}
                    variant={"contained"}
                    color="secondary"
                  >
                    {action === "create" ? "Create" : "Update"}
                  </Button>
                </div>
              </form>
            </div>
          ) : (
            <div className={classes.formWrapper}>
              Warning, deleting this feild will delete both the feild name and
              its type from the ordering list. Are you sure?
              <div className={classes.actionButtons}>
                <Button
                  disableElevation
                  disabled={loading}
                  type="button"
                  variant={"contained"}
                  onClick={handleClose}
                  style={{ textTransform: "initial" }}
                >
                  Cancel
                </Button>
                <Button
                  disableElevation
                  disabled={loading}
                  type="button"
                  variant={"contained"}
                  color="secondary"
                  onClick={handleDeleteFeild}
                  style={{ textTransform: "initial" }}
                >
                  Yes, Confirm
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

    </div>
  );
}

export default ManageModules;
